import { COO_KEEP_ON_TRACK_TASK } from './coo-keep-on-track'
import { COO_ONBOARD_CEO_TASK } from './coo-onboard-ceo'
import { IMPLEMENT_SELF_IMPROVEMENT_TASK } from './implement-self-improvement'
import { MEMBER_CREATE_TASK } from './member-create'
import { MEMBER_DELETE_TASK } from './member-delete'
import { MEMBER_UPDATE_TASK } from './member-update'
import { ROLE_CREATE_TASK } from './role-create'
import { ROLE_DELETE_TASK } from './role-delete'
import { ROLE_UPDATE_TASK } from './role-update'
import { TASK_CREATE_TASK } from './task-create'
import { TASK_DELETE_TASK } from './task-delete'
import { TASK_SELF_IMPROVEMENT_TASK } from './task-self-improvement'
import { TASK_UPDATE_TASK } from './task-update'
import { TEAM_CREATE_TASK } from './team-create'
import { TEAM_DELETE_TASK } from './team-delete'
import { TEAM_UPDATE_TASK } from './team-update'
import type { BuiltInTaskDefinition } from './types'

export const BUILT_IN_TASKS: readonly BuiltInTaskDefinition[] = [
    TEAM_UPDATE_TASK,
    TEAM_DELETE_TASK,
    TEAM_CREATE_TASK,
    TASK_UPDATE_TASK,
    TASK_SELF_IMPROVEMENT_TASK,
    TASK_DELETE_TASK,
    TASK_CREATE_TASK,
    ROLE_UPDATE_TASK,
    ROLE_DELETE_TASK,
    ROLE_CREATE_TASK,
    MEMBER_UPDATE_TASK,
    MEMBER_DELETE_TASK,
    MEMBER_CREATE_TASK,
    IMPLEMENT_SELF_IMPROVEMENT_TASK,
    COO_ONBOARD_CEO_TASK,
    COO_KEEP_ON_TRACK_TASK,
]
